import { labelsFor } from '@app/components/data-table/cascading-filter';
import { useMemo } from 'react';
import { useDataTableContext } from './use-server-data-table';

export const useGetFilterLabels = (filterNames: string[]) => {
  const { table } = useDataTableContext() ?? {};

  return useMemo(() => {
    if (!table) {
      return { labelsMap: {}, flatLabels: [] };
    }

    const labelsMap: Record<string, string[]> = {};
    const flatLabels: string[] = [];

    for (const name of filterNames) {
      const column = table.getColumn(name);
      const selectedValues = column?.getFilterValue() as string[] | undefined;
      const columnOptions = column?.columnDef.meta?.options;
      const columnNodes = column?.columnDef.meta?.nodes;

      // A cascading filter's value is one path, so it reads as one label.
      if (selectedValues && columnNodes) {
        const path = labelsFor(columnNodes, selectedValues);
        labelsMap[name] = path.length ? [path.join(' / ')] : [];
        flatLabels.push(...labelsMap[name]);
        continue;
      }

      if (!selectedValues || !columnOptions) {
        labelsMap[name] = [];
        continue;
      }

      const optionMap = new Map(
        columnOptions.map((opt: any) => [opt.value, opt.label])
      );

      const labels = selectedValues.map((val) => optionMap.get(val) ?? val);

      labelsMap[name] = labels;

      for (const label of labels) {
        flatLabels.push(`${label}`);
      }
    }

    return { labelsMap, flatLabels };
  }, [filterNames, table]);
};
